import { idZodSchema } from "@@/shared/id";
import { percentageZodSchema } from "@@/shared/percentage";
import { priceZodSchema } from "@@/shared/prices/price";
import type { Except } from "type-fest";
import { z } from "zod";
import { newManagedPaymentIdFactory } from "./new-managed-payment-id";

const onPremisePaidNewManagedPaymentZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("NEW_MANAGED_PAYMENT"),
    type: z.literal("ON_PREMISE_PAID"),
    /** How many percent of the change total this replacement is replacing */
    percentage: percentageZodSchema.optional(),
    /** Total value of the new on premise payment in selected currency */
    value: priceZodSchema,
});
type OnPremisePaidNewManagedPayment = z.infer<
    typeof onPremisePaidNewManagedPaymentZodObject
>;

type FactoryParams = Except<
    OnPremisePaidNewManagedPayment,
    "_id" | "_type" | "type"
>;
const onPremisePaidNewManagedPaymentFactory = (params: FactoryParams) => {
    const replacement: OnPremisePaidNewManagedPayment = {
        ...params,
        _id: newManagedPaymentIdFactory(),
        _type: "NEW_MANAGED_PAYMENT",
        type: "ON_PREMISE_PAID",
    };
    return replacement;
};

export {
    onPremisePaidNewManagedPaymentFactory,
    onPremisePaidNewManagedPaymentZodObject,
};
export type { OnPremisePaidNewManagedPayment };
